var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMountain1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 447,
    viewBox: "0 0 1440 447",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.156 76.4945C81.3508 105.618 -206.035 119.66 -206.035 119.66V420.788H231.153L1592.5 446.86V83.1596C1571.08 79.6834 1278.78 68.2988 1258.5 50.57C1233.16 28.4091 1219.58 50.57 1209.62 50.57C1199.67 50.57 1186.99 27.1055 1170.7 6.24816C1154.41 -14.6092 1129.06 36.2306 1110.96 50.57C1092.86 64.9095 1034.93 62.3023 1015.92 36.2306C996.911 10.1589 993.291 23.1947 975.188 36.2306C957.085 49.2665 923.224 38.6708 892.819 50.57C809.545 83.1596 776.054 67.5166 699.117 72.731C622.179 77.9453 534.379 38.0409 506.319 25.005C478.26 11.9692 461.967 -13.3057 408.563 8.85528C355.159 31.0162 331.625 66.6963 245.636 58.3914C198.662 53.8547 170.961 47.3711 126.156 76.4945Z",
    fill: "url(#paint0_radial)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(210.461 548.704) rotate(-12.2324) scale(1101.34 477.409)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E754A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19483,
    stopColor: "#DF59C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581608,
    stopColor: "#5E308A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F297E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountain1);
export default __webpack_public_path__ + "static/media/mountain1.1b4e48027472a314ec0819c12db6c1d5.svg";
export { ForwardRef as ReactComponent };